import { fontStyles } from '@/components/pdf/styles';
import { usePrintCurrencyString } from '@/utils/price';
import { Text, View } from '@react-pdf/renderer';
import { FunctionComponent } from 'react';

interface PurchaseOrderDocumentSummarySectionProps {
  totalProductPrice: number;
  totalDeviceFeePrice: number;
  regionCode?: string;
}

const PurchaseOrderDocumentSummarySection: FunctionComponent<PurchaseOrderDocumentSummarySectionProps> = ({
  totalProductPrice,
  totalDeviceFeePrice,
  regionCode
}) => {
  const printCurrencyString = usePrintCurrencyString({ regionCode });
  const formattedProductsPrice = printCurrencyString(totalProductPrice);
  const formattedDeviceFee = printCurrencyString(totalDeviceFeePrice);
  const formattedTotalProductAndDeviceFeePrive = printCurrencyString(totalProductPrice + totalDeviceFeePrice);

  return (
    <View
      style={{
        width: 250,
        border: '1px solid black',
        marginTop: 15
      }}
    >
      <Text style={{ ...fontStyles.bold, textAlign: 'center', marginBottom: 5, fontSize: 12 }}>Summary</Text>

      <View
        style={{
          flexDirection: 'row',
          fontSize: 10,
          justifyContent: 'space-between'
        }}
      >
        <Text style={{ ...fontStyles.bold, width: 150, marginLeft: 3 }}>Products & Services</Text>
        <Text style={{ ...fontStyles.italic, marginRight: 3 }}>{formattedProductsPrice}</Text>
      </View>

      <View
        style={{
          flexDirection: 'row',
          fontSize: 10,
          justifyContent: 'space-between',
          marginTop: 2
        }}
      >
        <Text style={{ ...fontStyles.bold, width: 150, marginLeft: 3 }}>Device Fees</Text>
        <Text style={{ ...fontStyles.italic, marginRight: 3 }}>{formattedDeviceFee}</Text>
      </View>

      <View
        style={{
          flexDirection: 'row',
          fontSize: 10,
          borderTop: '1px solid black',
          justifyContent: 'space-between',
          marginTop: 2
        }}
      >
        <Text style={{ ...fontStyles.bold, width: 150, marginLeft: 3 }}>Total</Text>
        <Text style={{ ...fontStyles.italic, marginRight: 3 }}>{formattedTotalProductAndDeviceFeePrive}</Text>
      </View>
    </View>
  );
};

export default PurchaseOrderDocumentSummarySection;
